import { environment } from './../environments/environment';

export const APP_CONFIG = {
  API_ENDPOINT: environment.API_ENDPOINT,
  NO_API_ENDPOINT: environment.NO_API_ENDPOINT,
};
